















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ModalWrapper from '@/wrappers/ModalWrapper.vue';
import Button from '@/components/Button.vue';
import http from '@/methods/http.ts';
import MaskedInput from 'vue-masked-input'

@Component({
    components: {
        ModalWrapper,
        Button,
        MaskedInput
    }
})
export default class AuthModal extends Vue {
    @Prop(Boolean) opened: boolean;

    @Watch('opened', {deep: true, immediate: true})
    onStateChange() {
        this.email = '';
        this.state = this.$store.state.authModal.tab;
    }
    
    state = 'auth';
    timer = setInterval(this.tick, 1000);
    seconds = 0;
    rememberMe = false;
    userId = '';
    activationCode = '';
    code = '';

    isEmail = true;
    isPhone = false;

    // data
    full_name = '';
    email = '';
    email_dublicate = '';
    pass = '';
    pass2 = '';
    username = '';
    token = '';
    new_password = '';
    new_password_confirm = '';

    /*
    @Watch('email', { deep: true, immediate: true })
    onEmailChange() {
        if (this.email.length === 0 || !/^[+]?\d+?$/.test(this.email)) {
            this.isEmail = true;
            this.isPhone = false;
            
            setTimeout(() => {
                document.getElementById('signInEmail').focus();
            }, 50);
            
        } else {
            this.isPhone = true;
            this.isEmail = false;

            setTimeout(() => {
                document.getElementById('signInPhone').lastChild['focus']();
            }, 50);
        }
    }
    */

    get timerState() {
        if (this.seconds === 60) return '01:00';
        return `00:${('0' + this.seconds).slice(-2)}`;
    }

    setTimer() {
        this.seconds = 60;
    }

    tick() {
        this.seconds !== 0 ? this.seconds = this.seconds - 1 : void(0);
    }

    isNumber(evt) {
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        let chars = [45,46,48,49,50,51,52,53,54,55,56,57,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122];
        if(chars.indexOf(charCode) !== -1) {
            return true;
        } else {
            evt.preventDefault();
        }
    }

    changeLogin() {
    }

    restorePassStep1() {
        if (this.username === '') {
            this.$store.commit('notificate', { text: 'Введите моб. телефон или адрес почты', type: 'error' });
            return false;
        }
        http('user/restore_password', 'post', false, {
            username: this.username.replace(/ /g, ''),
        }).then(r => {
            if (r.data.success === true) {
                this.userId = r.data.user_id;
                this.code = '';
                this.state = 'forget-pass-2';
                this.setTimer();
            } else {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            }
        }).catch(r => {
            this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
        });
    }

    restorePassStep2() {
        if (this.code === '') {
            this.$store.commit('notificate', { text: 'Введите код восстановления', type: 'error' });
            return false;
        }
        http('user/restore_password/confirm', 'post', false, {
            user_id: this.userId,
            code: this.code
        }).then(r => {
            if (r.data.success === true) {
                this.new_password = '';
                this.new_password_confirm = '';
                this.token = this.code;
                this.code = '';
                this.state = 'forget-pass-3';
            } else {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            }
        }).catch(r => {
            this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
        });
    }

    restorePassFinish() {
        if (this.new_password === '') {
            this.$store.commit('notificate', { text: 'Придумайте новый пароль', type: 'error' });
            return false;
        }
        if (this.new_password_confirm === '') {
            this.$store.commit('notificate', { text: 'Повторите пароль', type: 'error' });
            return false;
        }
        if (this.new_password !== this.new_password_confirm) {
            this.$store.commit('notificate', { text: 'Пароли не совпадают', type: 'error' });
            return false;
        }
        http('user/restore_password/change', 'post', false, {
            token: this.token,
            user_id: this.userId,
            new_password: this.new_password
        }).then(r => {
            if (r.data.success === true) {
                this.new_password = '';
                this.new_password_confirm = '';
                this.state = 'auth';
                this.$store.commit('notificate', { text: 'Пароль успешно изменен', type: 'action' });
            } else {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            }
        }).catch(r => {
            this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
        });
    }

    authenticate() {
        http('user/login', 'post', false, {
            username: this.email.replace(/ /g, ''),
            password: this.pass,
        }).then(r => {
            this.$store.commit('authenticate');
            this.$store.commit('setToken', r.data.token);
            this.$store.commit('notificate', { text: 'Рады снова вас видеть на checkin.kg!', type: 'action' });
            this.$emit('close-it');
        }).catch(error => {
            this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
        });
    }

    register() {
        if (this.pass !== this.pass2) {
            this.$store.commit('notificate', { text: 'Пароли не совпадают', type: 'error' });
            return false;
        }
        this.email_dublicate = this.email;
        http('user/create', 'post', false, {
            full_name: this.full_name.trim(),
            email: this.email_dublicate.replace(/ /g, ''),
            password: this.pass,
            username: this.email.replace(/ /g, ''),
        }).then(r => {
            this.state = 'activate-account';
            this.userId = r.data.user_id;
            this.email = this.email_dublicate.substring(3, this.email_dublicate.length).trim(); // убираем 996 из телефона
            this.setTimer();
        }).catch(error => {
            this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
        })
    }

    register_dublicate() {
        if (this.pass !== this.pass2) {
            this.$store.commit('notificate', { text: 'Пароли не совпадают', type: 'error' });
            return false;
        }
        http('user/create', 'post', false, {
            full_name: this.full_name.trim(),
            email: this.email_dublicate.replace(/ /g, ''),
            password: this.pass,
            username: this.email_dublicate.replace(/ /g, ''),
        }).then(r => {
            this.state = 'activate-account';
            this.userId = r.data.user_id;
            this.email = this.email_dublicate.substring(3, this.email_dublicate.length).trim(); // убираем 996 из телефона
            this.setTimer();
        }).catch(error => {
            this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
        })
    }

    registerStep2() {
        http('user/create/confirm', 'post', false, {
            code: this.activationCode,
            user_id: this.userId,
        }).then(r => {
            this.state = 'reg-ready'
        }).catch(r => {
            this.$store.commit('notification', { text: 'Вы ввели неправильный код', type: 'error' });
        })
    }
    
}

